import { Inject, Injectable } from '@angular/core';
import { Dictionary } from '../../../shared/models/dictionary';
import { EntityTypes } from '../../entity/entity-types';
import { API_URL } from '../../app-store-providers';
import { HttpClient } from '@angular/common/http';
import { StoreBaseService } from '../../common/base.service';

@Injectable({
  providedIn: 'root'
})
export class DictionaryAcquisitionService
  extends StoreBaseService<Dictionary> {

  get entityType(): string {
    return EntityTypes.acquisition;
  }

  get resourceName(): string {
    return 'acquisition';
  }

  constructor(
    @Inject(API_URL) apiUrl: string,
    http: HttpClient
  ) {
    super(apiUrl, http);
  }
}
